import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type SPTableDataEmptyLoc = 'SPTableDataEmptyContent';

export const spTableDataEmptyLocs: LocDefs<SPTableDataEmptyLoc> = {
	SPTableDataEmptyContent: {
		defaultValue: 'No data to show',
		description: 'Text displayed when the data table or grid has no data to display',
		displayPath: 'Data View|No Data Found',
		displayType: 'Content',
		shared: true,
		portal: 'SP',
		feature: HubFeature.Core,
	},
};

export const LOC_KEYS = MapLocKeys<SPTableDataEmptyLoc>(spTableDataEmptyLocs);
export type SPTableDataEmptyLocType = LocMap<SPTableDataEmptyLoc>;
